import { goFetch } from "@/utils/network-utils";
import type {
    EnrollmentDTO,
    EnrollmentInputDTO,
    EnrollmentResponseDTO,
    GetUserEnrollmentsRequestDTO,
    GetUserEnrollmentsResponseDTO
} from "@tmi/types/api/user-notifications";
import type { ApiFetchResponse } from "@tmi/types/api/fetch";

export async function addOrUpdateEnrollment( authToken: string | null, input: EnrollmentInputDTO ): Promise< ApiFetchResponse< EnrollmentResponseDTO > > {
    // we currently use the server response because the response tells us if there were contacts that need confirmation
    // and the server does not currently have confirmations enabled.
    return await goFetch< EnrollmentResponseDTO, EnrollmentInputDTO > ( {
        endpoint: `usernotification/enrollment`,
        payload: input,
        authToken: authToken,
        forceThrowExceptions: true
    } );
}

export async function getAllUserEnrollments( authToken: string | null ): Promise< Array< EnrollmentDTO > | undefined > {
    const request: GetUserEnrollmentsRequestDTO = {
        includeNotifications: true,
        includeScopes: false
    };

    const response =
        await goFetch< GetUserEnrollmentsResponseDTO, GetUserEnrollmentsRequestDTO >( {
            endpoint: `usernotification/getUserEnrollments`,
            authToken: authToken,
            payload: request
        } );

    return response?.data;
}
